import { render } from "./m-edit-plan.vue?vue&type=template&id=6ff89650&scoped=true"
import script from "./m-edit-plan.vue?vue&type=script&lang=js"
export * from "./m-edit-plan.vue?vue&type=script&lang=js"

import "./m-edit-plan.vue?vue&type=style&index=0&id=6ff89650&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff89650"]])

export default __exports__